import type { ReactNode } from 'react';

export const symbol_mobile_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M829-49 49-843q-8-9-8.5-21t8.5-21q9-9 21-9t21 9L872-91q9 9 8.5 21T871-49q-9 9-21 9t-21-9ZM260-920h440q24.75 0 42.38 17.62Q760-884.75 760-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v168q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-491H200q0-24 17.63-42 17.62-18 42.37-18Zm240 191q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9ZM260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-674l60 61v613h440v-166l60 61v105q0 24.75-17.62 42.37Q724.75-40 700-40H260Zm177-366Zm117-97Z"
		/>
	</svg>
);
